import { getRecognition, Recognition, RecognitionEmbeds } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

export const GET_RECOGNITION_QK = 'GET_RECOGNITION_QUERY_KEY'

// Full embed set used when viewing a single recognition (includes interaction
// embeds like reactions/comments/endorsements that only exist on published posts).
export const recognitionViewEmbeds: RecognitionEmbeds[] = [
  'sendToAndSender',
  'qualities',
  'attachmentUrls',
  'endorsementStats',
  'reactionCounts',
  'comments',
  'recipientCount',
  'ownRecipient',
]

const useGetRecognition = (
  embeds: RecognitionEmbeds[],
  recognitionId?: string,
  enabled: boolean = true,
) => {
  const [recognition, setRecognition] = useState<Recognition>()

  const { data, isFetched, isLoading, refetch } = useQuery({
    queryKey: [GET_RECOGNITION_QK, recognitionId, [...embeds].sort()],
    queryFn: () => getRecognition(recognitionId ?? '', embeds),
    enabled: !!recognitionId && enabled,
  })

  useEffect(() => {
    if (recognitionId && data) {
      setRecognition(data)
    } else {
      setRecognition(undefined)
    }
  }, [data, recognitionId])

  return {
    isFetched,
    isLoading,
    recognition,
    refetch,
  }
}

export default useGetRecognition
